import { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";
import { WeekDay } from "../../shared/WeekDay";

export default {
   rental: {
      rentalCondition: [
         {
            title: "pro Tag",
            remarks: "",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: null,
            rentalDurationDays: 1
         },

         {
            title: "pro Tag [Verband]",
            remarks: "",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: null,
            rentalDurationDays: 1
         },

         {
            title: "Wochenende",
            remarks: "Donnerstag bis Montag",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: WeekDay.Thursday,
            rentalDurationDays: 4
         },

         {
            title: "Wochenende [Verband]",
            remarks: "Donnerstag bis Montag",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: WeekDay.Thursday,
            rentalDurationDays: 4
         },

         {
            title: "Woche",
            remarks: "Woche = 7 Tage (z.B. Mittwoch bis Dienstag) \nBitte beachten Sie, dass wir immer ganze Wochen abrechnen (ggf. kann eine andere Kondition günstiger sein).",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: null,
            rentalDurationDays: 6
         },

         {
            title: "Woche [Verband]",
            remarks: "Woche = 7 Tage (z.B. Mittwoch bis Dienstag) \nBitte beachten Sie, dass wir immer ganze Wochen abrechnen (ggf. kann eine andere Kondition günstiger sein).",
            cancellationFee: 1000,
            cancellationRemarks: "",
            rentalDurationStartWeekDay: null,
            rentalDurationDays: 6
         }
      ],

      additionalRentalCondition: []
   },
} as PriceTemplateManual;